import { createMuiTheme } from 'material-ui/styles';
import blueGrey from 'material-ui/colors/blueGrey';

export default createMuiTheme({

  palette: {
    type: 'light',
    primary: blueGrey
  },

  qborder: {
    background: {
      hover: 'rgba(0, 0, 0, 0.12)',
      flash: 'rgba(0, 0, 0, 0.3)',
      code: 'rgba(0, 0, 0, 0.05)'
    }
  },

  overrides: {

    MuiTooltip: {

      tooltipBottom: {
        margin: '0 !important'
      }

    },

    MuiBackdrop: {

      root: {
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: '0'
      }

    },

    MuiTable: {

      root: {
        overflow: 'auto'
      }

    },

    MuiTableRow: {

      root: {
        height: '32px'
      },

      typeHead: {
        height: '32px'
      }

    }

  }

});




// WEBPACK FOOTER //
// ./src/shared/themes/light.js